"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KameleonFooterComponent = void 0;
var kameleon_block_renderer_1 = require("../helpers/kameleon-block-renderer");
var types_1 = require("@kameleon-core/types");
var lodash_1 = require("lodash");
var kameleon_primary_component_1 = require("./kameleon-primary-component");
/**
 * Renders the KameleonFooterBlock.
 * @param element
 * @param kameleonProps
 * @param mergeWithDefault
 * @constructor
 */
var KameleonFooterComponent = function (_a) {
    var element = _a.element, kameleonProps = _a.kameleonProps, _b = _a.mergeWithDefaults, mergeWithDefaults = _b === void 0 ? false : _b;
    var _c = (0, lodash_1.cloneDeep)(kameleonProps), widgetBlocks = _c.widgetBlocks, blockProps = _c.blockProps;
    return (0, kameleon_block_renderer_1.blockAsLazy)(element, function (loadedElement, defaultProps) {
        var updatedProps = __assign({}, defaultProps);
        var layoutProps = __assign(__assign({}, updatedProps === null || updatedProps === void 0 ? void 0 : updatedProps.layoutProps), blockProps === null || blockProps === void 0 ? void 0 : blockProps.layoutProps);
        if (types_1.BlockType.Footer === loadedElement.component.blockType) {
            var FooterWidgetBlocks = widgetBlocks === null || widgetBlocks === void 0 ? void 0 : widgetBlocks.map(function (widgetBlock) {
                return {
                    block: (0, kameleon_block_renderer_1.blockAsLazy)(widgetBlock.packageName),
                    props: __assign({ layoutProps: __assign({}, layoutProps) }, widgetBlock.blockProps),
                };
            });
            updatedProps = __assign(__assign(__assign({ layoutProps: layoutProps }, updatedProps), { FooterWidgetBlocks: FooterWidgetBlocks }), (0, kameleon_primary_component_1.lazySecondaryAndTertiary)(kameleonProps.secondaryBlockPackageName, kameleonProps.tertiaryBlockPackageName, layoutProps, kameleonProps.secondaryBlockProps, kameleonProps.tertiaryBlockProps));
        }
        return (0, kameleon_block_renderer_1.ensureCorrectBlockProps)(blockProps, updatedProps, mergeWithDefaults === true);
    });
};
exports.KameleonFooterComponent = KameleonFooterComponent;
